.button {
  --button-bg: var(--wv-surface);
  --button-fg: var(--wv-text);
  --button-border: var(--wv-border-strong);
  --button-bg-hover: var(--wv-surface-2);

  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--wv-space-2);
  block-size: var(--wv-control-height-md);
  padding-inline: var(--wv-space-4);
  border: 1px solid var(--button-border);
  border-radius: var(--wv-radius-2);
  background: var(--button-bg);
  color: var(--button-fg);
  font: inherit;
  font-size: var(--wv-text-sm);
  font-weight: var(--wv-weight-medium);
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  user-select: none;
  transition:
    background-color var(--wv-duration-fast) var(--wv-ease),
    border-color var(--wv-duration-fast) var(--wv-ease),
    box-shadow var(--wv-duration-fast) var(--wv-ease);
}

.button:hover:not(:disabled, [aria-disabled="true"]) {
  background: var(--button-bg-hover);
}

.button:active:not(:disabled, [aria-disabled="true"]) {
  transform: translateY(1px);
}

.button:focus-visible {
  outline: 2px solid var(--wv-focus);
  outline-offset: 2px;
}

.button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.button[data-loading] {
  cursor: progress;
}

.button[data-variant="primary"] {
  --button-bg: var(--wv-accent);
  --button-bg-hover: var(--wv-accent-hover);
  --button-fg: var(--wv-accent-contrast);
  --button-border: transparent;
  box-shadow: var(--wv-shadow-1);
}

.button[data-variant="danger"] {
  --button-bg: var(--wv-danger);
  --button-bg-hover: var(--wv-danger);
  --button-fg: var(--wv-danger-contrast);
  --button-border: transparent;
}

.button[data-variant="danger"]:hover:not(:disabled, [aria-disabled="true"]) {
  filter: brightness(0.92);
}

.button[data-variant="ghost"] {
  --button-bg: transparent;
  --button-border: transparent;
}

.button[data-size="sm"] {
  block-size: var(--wv-control-height-sm);
  padding-inline: var(--wv-space-3);
  font-size: var(--wv-text-xs);
}

.button[data-size="lg"] {
  block-size: var(--wv-control-height-lg);
  padding-inline: var(--wv-space-6);
  font-size: var(--wv-text-md);
}

.button[data-full-width] {
  inline-size: 100%;
}

.icon {
  display: inline-flex;
  font-size: 1.1em;
}

.label {
  overflow: hidden;
  text-overflow: ellipsis;
}
